import { get } from 'lodash';
import { func, object, string } from 'prop-types';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

const DisplayOption = ({ item, onChange, title }) => {
  const [value, setValue] = useState(get(item.attributes, 'hidden'));

  useEffect(() => {
    setValue(!get(item.attributes, 'hidden'));
  }, [get(item.attributes, 'hidden')]);

  const handleChange = (e) => {
    e.preventDefault();
    const newValue = e.target.checked;

    setValue(newValue);

    onChange({
      id: item.id,
      settingKey: 'attributes.hidden',
      value: !newValue,
    });
  };

  return (
    <Wrapper>
      <InputTitle id={item.id} label={title} position="left" />
      <CheckboxInput
        id={item.id}
        name={item.id}
        onChange={handleChange}
        value={value}
        width="auto"
      />
    </Wrapper>
  );
};

export default DisplayOption;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  my: 2,
}))``;

DisplayOption.defaultProps = {
  title: __('Display'),
};

DisplayOption.propTypes = {
  item: object.isRequired,
  onChange: func.isRequired,
  title: string,
};
